import { render } from "./TreeFolder.vue?vue&type=template&id=37286c97&ts=true"
import script from "./TreeFolder.vue?vue&type=script&lang=ts"
export * from "./TreeFolder.vue?vue&type=script&lang=ts"

import "./TreeFolder.vue?vue&type=style&index=0&id=37286c97&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__